import { TKV2_ORDER_ATTACHMENT_API, Tkv2MarketConditionsAttachment } from '@aloft/toolkit-shared';
import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { fetchGetTkv2MarketConditionsAPI } from '../../hooks/api/toolkitComponents.js';
import { useToolkitContext } from '../../hooks/api/toolkitContext.js';

export function useTkv2MarketConditions(
  params: { pathParams: { orderID: string } },
  opts?: UseQueryOptions<Tkv2MarketConditionsAttachment>,
): UseQueryResult<Tkv2MarketConditionsAttachment> {
  const { fetcherOptions } = useToolkitContext();
  return useQuery<Tkv2MarketConditionsAttachment>(
    ['order', params.pathParams.orderID, 'marketConditions'],
    async () => {
      const res = await fetchGetTkv2MarketConditionsAPI({ ...fetcherOptions, ...params });
      return TKV2_ORDER_ATTACHMENT_API.MARKET_CONDITIONS.GET.RESPONSE.parse(res);
    },
    opts,
  );
}
